import type { SortDirection } from '../types/Filters';

/** Helpers dos hooks de filtro na URL (`useAllocationFilters`, `usePoolFilters`, `useUnallocatedFilters`). */

export const SORT_DIRECTIONS = ['asc', 'desc'] as const satisfies readonly SortDirection[];

const MIN_PERCENTAGE = 0;
const MAX_PERCENTAGE = 100;

/** O input numérico do funil aceita qualquer número; a API só aceita inteiro de 0 a 100. */
export function toPercentageBound(value: number | null): number | null {
  if (value === null || Number.isNaN(value)) return null;
  return Math.min(MAX_PERCENTAGE, Math.max(MIN_PERCENTAGE, Math.round(value)));
}

/** Texto em branco sai da URL. */
export const textOrNull = (value: string): string | null => value.trim() || null;

/** Lista vazia sai da URL. */
export const idsOrNull = (ids: number[]): number[] | null => (ids.length > 0 ? ids : null);

/** Id + rótulo gravados lado a lado na URL; só vira seleção com os dois presentes. */
export function selectionFrom(
  id: number | null,
  name: string | null,
): { id: number; name: string } | null {
  return id !== null && name !== null ? { id, name } : null;
}

/** Sem o rótulo (URL editada à mão) mostra o id, para não esconder um filtro que continua valendo. */
export function selectionsFrom(
  ids: number[] | null,
  names: string[] | null,
): { id: number; name: string }[] {
  return (ids ?? []).map((id, index) => ({ id, name: names?.[index] ?? String(id) }));
}

/** Junta os campos de cada filtro removível num só objeto que limpa todos. */
export function allFiltersCleared<K extends string>(
  clearedByKey: Record<K, Record<string, null>>,
): Record<string, null> {
  return Object.assign({}, ...Object.values<Record<string, null>>(clearedByKey));
}

/** Algum campo de algum filtro removível está na URL. */
export function hasAnyFilter<K extends string>(
  clearedByKey: Record<K, Record<string, null>>,
  state: Record<string, unknown>,
): boolean {
  return Object.keys(allFiltersCleared(clearedByKey)).some((field) => state[field] != null);
}
